import React from 'react';

import Row from "./../../../common/components/Row.js";
import Col from "./../../../common/components/Col.js";
import Card from "./../../../common/components/Card.js";
import Button from "./../../../common/components/Button.js";
import Typo from "./../../../common/components/Typo.js";


const FormSuccess = ({onConfirm}) => {

  return (

    <Card>
      <Typo variant="h1">Success</Typo><br/>
      <>Well done.</>

      <Row>
        <Col widthmd="12">
          <Button onClick={() => onConfirm({
            action: "navigate",
            params: {
              page: "login"
            }
          })}>Sign in</Button>
        </Col>
      </Row>
    </Card>
  )
}

export default FormSuccess;
